var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 8.99992H7.66683V10.3333H6.3335V8.99992ZM6.3335 3.66659H7.66683V7.66659H6.3335V3.66659ZM6.9935 0.333252C3.3135 0.333252 0.333496 3.31992 0.333496 6.99992C0.333496 10.6799 3.3135 13.6666 6.9935 13.6666C10.6802 13.6666 13.6668 10.6799 13.6668 6.99992C13.6668 3.31992 10.6802 0.333252 6.9935 0.333252ZM7.00016 12.3333C4.0535 12.3333 1.66683 9.94659 1.66683 6.99992C1.66683 4.05325 4.0535 1.66659 7.00016 1.66659C9.94683 1.66659 12.3335 4.05325 12.3335 6.99992C12.3335 9.94659 9.94683 12.3333 7.00016 12.3333Z",
    fill: "#E71111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.2d0ba4eec5a21c7535ad4ad717185d85.svg";
export { ForwardRef as ReactComponent };